export function formatDate(dateTime) {
    const today = new Date();
    const date = new Date(dateTime)

    if (today.toLocaleDateString("en-US") === date.toLocaleDateString("en-US")) {
        return "Today";
    }

    const ordinals = ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"]
    const ordinal = ordinals[date.getDate() % 10];

    return `${date.toLocaleDateString("en-US", { weekday: 'long', month: 'short', day: 'numeric' })}${ordinal}`;
}

export function formatTime(dateTime) {
    const time = new Date(dateTime);
    return time.toLocaleString("en-US", { timeStyle: 'long'});
}

export function formatDateTime(dateTime) {
    return `${formatDate(dateTime)} @ ${formatTime(dateTime)}`;
}